import { connect } from "react-redux";
import AccountsSortBar from "./AccountsSortBar";
import { setAccountsSort, SORT_BY } from "./actions/sort";

const mapStateToProps = (state, ownProps) => {
  return {
    sortBy: state.ui.sortAccounts
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onSortBy: (key, direction = "asc") => {
      switch (key) {
        case "status":
          dispatch(setAccountsSort(SORT_BY.STATUS));
          break;
        case "date":
          if (direction === "asc") {
            dispatch(setAccountsSort(SORT_BY.DATE_ASC));
          } else {
            dispatch(setAccountsSort(SORT_BY.DATE_DESC));
          }
          break;
        default:
          dispatch(setAccountsSort(SORT_BY.NAME));
      }
    }
  };
};

const AccountsSortBarContainer = connect(mapStateToProps, mapDispatchToProps)(
  AccountsSortBar
);

export default AccountsSortBarContainer;



// WEBPACK FOOTER //
// ./src/AccountsSortBarContainer.js